/* eslint-disable react/display-name */
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { getImage, ImageSize } from '../../../../../shared/utils/imageFormat';

const useStyles = makeStyles(() => ({
  slideContainer: {
    minHeight: 60,
  },
  slide: {
    width: '100vw',
    height: '100vh',
    top: 0,
    left: 0,
    position: 'absolute',
    backgroundColor: '#000000',
  },
  image: {
    width: '100vw',
    height: '100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'contain',
    backgroundPosition: 'center',
  },
  slideNr: {
    position: 'absolute',
    top: 3,
    left: 3,
    height: 17,
    lineHeight: '17px',
    padding: '0 5px',
    fontSize: 10,
    fontWeight: 600,
    backgroundColor: '#000',
    color: '#ffffff',
    borderRadius: 10,
    opacity: 0.6,
    userSelect: 'none',
  },
  embedHolder: {
    width: '100%',
    height: 0,
    position: 'relative',
    paddingBottom: '56.25%',
    backgroundColor: '#000000',
  },
  embed: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
  slideText: {
    whiteSpace: 'pre-wrap',
    maxHeight: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
  },
}));

export const EntitySlideFullscreen = React.memo((props) => {
  const classes = useStyles();
  const typeRender = {
    text: (data) => (
      <Box
        p={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
        className={classes.slide}
      >
        <Box className={classes.slideText}>{data.data.text}</Box>
      </Box>
    ),
    image: (data) => (
      <Box
        className={classes.image}
        style={{
          backgroundImage: `url(${getImage(data.data.src, ImageSize.Large)})`,
        }}
      ></Box>
    ),
    iframe: (data) => (
      <Box className={classes.slide}>
        <iframe
          frameBorder="0"
          allow="fullscreen;camera;microphone"
          className={classes.slide}
          src={data.data.src}
        />
      </Box>
    ),
  };
  return (
    <Box className={classes.slide}>
      {typeRender[props.data.type](props.data)}
    </Box>
  );
});
